import { ReactSurveyElement } from 'survey-react-ui';
import type { ItemValue } from 'survey-core';

import { IonSelectOption } from '@ionic/react';

export class SurveyDropdownItem extends ReactSurveyElement {
  protected get item(): ItemValue {
    return this.props.item;
  }

  renderElement() {
    return (
      <IonSelectOption value={this.item.value}>
        {this.item.text}
      </IonSelectOption>
    );
  }
}
